import { breakpoint, styled } from '../styled-components'

export const Content = styled.div`
  background: white;
  border-radius: 3px;
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.01);
  ${breakpoint('tablet')`
    padding: 40px;
  `}
`

export const SplitContentContainer = styled(Content)<{ noMinHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  ${props => !props.noMinHeight && 'min-height: 580px;'};
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

export const ContentContainerBody = styled.div<{ padded?: boolean, vertical?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;
  ${breakpoint('tablet')`
    ${props => props.padded ? 'padding: 40px;' : 'padding: 0 40px 0 0;'}
    flex-direction: ${props => props.vertical ? 'column' : 'row'};  
  `}
`

export const ContentRow = styled.div<{ vertical?: boolean, padded?: boolean, paddedVertically?: boolean }>`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  margin-bottom: 20px;
  padding: 20px 0;
  flex: 1;
  
  &:last-child {
    border-bottom: 0;
    border-right: 0;
    margin-bottom: 0;
  }
  ${breakpoint('tablet')`
    margin-bottom: 0;
    padding: 0; 
    ${props => `
      ${props.padded && 'padding: 20px'};
      ${props.paddedVertically && 'padding: 20px 0'};
    `};
    flex-direction: ${props => props.vertical ? 'column' : 'row'};
    ${props => props.vertical && `border-bottom: 0; border-right: 1px solid ${props.theme.borderColor}`}
  `}
`

export const FlexItem = styled.div`
  flex: 1 0 0;
`
